import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Laura M.',
    role: 'Propietaria de salón',
    text: 'Desde que uso BeautyBookAI, mis reservas han aumentado un 35%. La gestión de citas es increíblemente fácil y mis clientes adoran poder reservar online.',
    rating: 5,
  },
  {
    name: 'Carlos R.',
    role: 'Barbero independiente',
    text: 'Los agentes de IA atienden mis llamadas cuando estoy con un cliente. Es como tener una recepcionista 24/7 sin el coste adicional.',
    rating: 5,
  },
  {
    name: 'María J.',
    role: 'Estilista y colorista',
    text: 'La facturación automática y el control horario me han ahorrado horas de trabajo administrativo cada semana. Ahora puedo centrarme en lo que más me gusta.',
    rating: 5,
  },
  {
    name: 'Ana P.',
    role: 'Clienta',
    text: 'Encontré a mi peluquera ideal en menos de 5 minutos. Reservar es super fácil y los recordatorios me encantan. No volvería a buscar de otra forma.',
    rating: 5,
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-20 px-4 bg-beige">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-[#2B2520]">
            Lo que dicen de nosotros
          </h2>
          <p className="font-body text-[#8C7E6F] max-w-2xl mx-auto">
            Profesionales y clientes que ya confían en BeautyBookAI
          </p>
        </div>

        {/* Desktop: 2x2 grid, Mobile: horizontal scroll with snap */}
        <div className="hidden md:grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} testimonial={t} />
          ))}
        </div>

        <div className="flex md:hidden gap-4 overflow-x-auto snap-x snap-mandatory pb-4 -mx-4 px-4 scrollbar-hide">
          {testimonials.map((t, i) => (
            <div key={i} className="snap-center shrink-0 w-[85vw]">
              <TestimonialCard testimonial={t} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial }: { testimonial: typeof testimonials[number] }) {
  const initial = testimonial.name.charAt(0);

  return (
    <div className="bg-white rounded-[20px] p-7 h-full flex flex-col shadow-ref-card relative">
      {/* Decorative quote mark */}
      <span className="absolute top-5 right-6 font-heading text-6xl text-[#B8860B]/10 leading-none select-none">
        "
      </span>

      <div className="flex gap-1 mb-4">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-[#B8860B] text-[#B8860B]" />
        ))}
      </div>

      <p className="font-heading text-[#2B2520] leading-relaxed flex-1 mb-5 italic text-[0.95rem]">
        "{testimonial.text}"
      </p>

      <div className="flex items-center gap-3">
        {/* Avatar with gold gradient border */}
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#B8860B] to-[#D4A526] flex items-center justify-center">
          <span className="font-heading text-white text-sm font-bold">{initial}</span>
        </div>
        <div>
          <p className="font-body font-semibold text-[#2B2520]">{testimonial.name}</p>
          <p className="font-body text-sm text-[#8C7E6F]">{testimonial.role}</p>
        </div>
      </div>
    </div>
  );
}
